/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_RequiredInputs */

const en_settings_tickets_required = /** @type {(inputs: Settings_Tickets_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject and description are required`)
};

/**
* | output |
* | --- |
* | "Subject and description are required" |
*
* @param {Settings_Tickets_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_required = /** @type {((inputs?: Settings_Tickets_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_required(inputs)
});
export { settings_tickets_required as "settings.tickets.required" }